import React from 'react';
import { motion } from 'framer-motion';
import { FileCheck } from 'lucide-react';
import { SlipVerificationTab } from '../components/admin/SlipVerificationTab';

export const VerificationPage: React.FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8"
    >
      {/* Header */}
      <div className="flex items-center gap-4 mb-8">
        <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center">
          <FileCheck size={24} className="text-primary" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-text-primary-light dark:text-text-primary-dark">
            Slip Verification
          </h1>
          <p className="text-text-secondary-light dark:text-text-secondary-dark">
            Review and verify user-submitted betting slips
          </p>
        </div>
      </div>

      {/* Verification Content */}
      <SlipVerificationTab />
    </motion.div>
  );
};

export default VerificationPage;
